// import PackageRequestMain from "../../../../features/customer/package-request/components/package-request-main";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../../store/ui-slice";
import CustomerVoucherMain from "../../../../features/customer/customer-voucher/components/customer-voucher-main";

const title = "Customer Voucher";

const CustomerVoucherPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <CustomerVoucherMain />;
  // return "Customer Voucher Page";
};

export default CustomerVoucherPage;
